import { useQuery } from '@tanstack/react-query';
import { axios } from '@/src/lib/axios/axios';
import { QueryConfig } from '@/src/lib/react-query/react-query';
import { messagingQueryKeys } from '../config';
import { UserInfo } from '../types/backend';

export interface InternalUsersResponse {
  rows: UserInfo[];
  count: number;
}

export type InternalUsersQuery = {
  search?: string;
  limit?: number;
  offset?: number;
};

const getInternalUsers = async (
  params: InternalUsersQuery = {}
): Promise<InternalUsersResponse> => {
  const { search, limit = 100, offset = 0 } = params;

  const queryParams = new URLSearchParams({
    limit: String(limit),
    offset: String(offset),
  });

  if (search) {
    queryParams.append('search', search);
  }

  // Note: This endpoint needs to be implemented in the backend
  // Backend should create: GET /api/messaging/internal-users
  // Returns: { rows: UserInfo[], count: number }
  // Query params: ?search=<string>&limit=<number>&offset=<number>
  // UserInfo: { id, firstName, lastName, avatar, userType? }
  return axios.get(`/api/messaging/internal-users?${queryParams}`);
};

type QueryFnType = typeof getInternalUsers;

type UseInternalUsersOptions = {
  search?: string;
  limit?: number;
  offset?: number;
  config?: QueryConfig<QueryFnType>;
};

export const useInternalUsers = ({
  search,
  limit,
  offset,
  config,
}: UseInternalUsersOptions = {}) => {
  return useQuery({
    queryKey: [...messagingQueryKeys.internalUsers(search)],
    queryFn: () => getInternalUsers({ search, limit, offset }),
    staleTime: 60000, // Cache for 1 minute
    ...config,
  });
};
